import React from "react"
import BackArrow from "./back-arrow"
import USD from "../usd"

const Stats = (props) => {
  const session = props.lastSessionId && props.sessions.find(s => s.id == props.lastSessionId)
  if (!session) return null
  const {cashAmount, startingCashAmount} = session
  const endingCashAmount = parseFloat(props.endingCashAmountEntered)
  const difference = endingCashAmount - cashAmount - startingCashAmount
  let color, header, sign
  if (difference < 0) {
    color = "red"
    header = "Your are under"
    sign = "-"
  } else if (difference > 0) {
    color = "green"
    header = "Your are over"
    sign = "+"
  } else {
    color = ""
    header = "Cash amount looks good!"
    sign = ""
  }
  const absDifference = Math.abs(difference)
  return (
    <div className="clock-in-panel__info-window clock-in-stats" style={props.cashBalanceStyle}>
      <BackArrow {...props}/>
      <div className="clock-in-window">
        <h1>{header}</h1>
        <div className="clock-in-stats__total">
          <USD className={color} space val={absDifference}/>
        </div>
        <table className="clock-in-stats-table">
          <tbody>
            <tr><td>Starting Amount</td><td><USD space val={startingCashAmount}/></td></tr>
            <tr><td>Total Cash Sales</td><td><USD space val={cashAmount}/></td></tr>
            <tr><td>Ending Amount Entered</td><td><USD space val={endingCashAmount}/></td></tr>
            <tr>
              <td>Difference</td>
              <td className={color}>{sign}<USD space val={absDifference}/></td>
            </tr>
          </tbody>
        </table>
        <button onClick={props.onClickBack}>Go back</button>
        <button onClick={props.onConfirmClockOut}>Clock out</button>
      </div>
    </div>
  )
}

export default Stats
